import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';
import {
  ArrowLeftOnRectangleIcon,
  UserCircleIcon,
  BellIcon,
  ShieldCheckIcon
} from '@heroicons/react/24/outline';

const Profile = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const menuItems = [
    { icon: UserCircleIcon, label: 'Edit Profil', action: () => navigate('/profile/edit') },
    { icon: BellIcon, label: 'Notifikasi', action: () => navigate('/notifications') },
    { icon: ShieldCheckIcon, label: 'Keamanan', action: () => navigate('/profile/security') }
  ];

  return (
    <div className="min-h-screen bg-white pb-24">
      {/* Profile Header */}
      <div className="bg-surface px-6 pt-12 pb-8 rounded-b-[32px] mb-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="flex flex-col items-center text-center"
        >
          <img
            src={`https://api.dicebear.com/9.x/micah/svg?seed=${user?.name || 'User'}`}
            alt="Avatar"
            className="w-24 h-24 rounded-full border-4 border-white shadow-soft mb-4"
          />
          <h2 className="text-2xl font-bold text-slate-900">{user?.name || 'Pengguna'}</h2>
          <p className="text-sm text-slate-600 mb-2">{user?.email || 'user@email.com'}</p>
          {user?.is_google_linked ? (
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
              Terhubung dengan Google
            </span>
          ) : (
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-800">
              Email Standar
            </span>
          )}
        </motion.div>
      </div>

      {/* Menu */}
      <div className="px-6 space-y-3">
        {menuItems.map((item, idx) => {
          const Icon = item.icon;
          return (
            <motion.button
              key={idx}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: idx * 0.1 }}
              onClick={item.action}
              data-testid={`profile-${item.label.toLowerCase().replace(/\s/g, '-')}`}
              className="w-full flex items-center gap-4 p-4 bg-white border border-border rounded-3xl hover:bg-surface transition-colors text-left"
            >
              <div className="w-10 h-10 bg-surface rounded-full flex items-center justify-center">
                <Icon className="w-5 h-5 text-primary" />
              </div>
              <span className="font-medium text-slate-900">{item.label}</span>
            </motion.button>
          );
        })}

        <motion.button
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.3 }}
          onClick={handleLogout}
          data-testid="profile-logout-btn"
          className="w-full flex items-center gap-4 p-4 bg-danger-bg border border-danger/20 rounded-3xl hover:bg-danger/10 transition-colors text-left mt-6"
        >
          <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
            <ArrowLeftOnRectangleIcon className="w-5 h-5 text-danger" />
          </div>
          <span className="font-medium text-danger">Logout</span>
        </motion.button>
      </div>
    </div>
  );
};

export default Profile;
